<template>
    <div>
        <b-card no-body class="dropEmpresa bg-gradient-warning p-1" v-if="options">
            <b-avatar :src="logo"></b-avatar>
            <b-form-group :label="label" :label-sr-only="noLabel">
            <b-input-group>
                <slot name="prepend"></slot>
                <b-form-input
                class="dropEmpresa-field"
                :state="state"
                :readonly="disabled"
                :placeholder="placeholder"
                autocomplete="off"
                @focus="showOptions()"
                @blur="exit()"
                @keyup="keyMonitor"
                v-model="searchFilter"    
                />
                <slot name="append"></slot>
                <b-form-invalid-feedback v-if="!hideFeedback">{{ feedback }}</b-form-invalid-feedback>
            </b-input-group>
            </b-form-group>
        </b-card>
        <b-card no-body class="dropEmpresa-content p-0" v-show="optionsShown">
            <div
                class="dropEmpresa-item d-flex"
                @mousedown="selectOption(option)"
                v-for="(option, index) in filteredOptions"
                :key="index">
                    <div class="flex-grow-1">
                        <b-avatar class="mr-2" size="sm" :src="option.logo"></b-avatar>
                        {{ option.text || '-' }}                        
                    </div>
                    <div class="align-items-center">
                        <b-badge  :variant="option.data.tipo =='Executora' ? 'info' : 'primary'">{{option.data.tipo}}</b-badge>
                    </div>
            </div>
        </b-card>
    </div>
</template>

<script>
  export default {
    name: 'InputSelectFilter',
    props: {      
      hideFeedback: { type: Boolean, default: false },
      noLabel: { type: Boolean, default: false },
      label: { type: String },
      options: {
        type: Array,
        required: true,
        default: () => [],
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Selecione uma empresa',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      maxItem: {
        type: Number,
        required: false,
        default: 6,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      value: {
        default: '',
      },
    },
    data() {
      return {
        selected: {},
        optionsShown: false,
        searchFilter: '',
        validForm: false,
        hasError: false,
        errorMessage: "",
        
      }
    },
    created() {
      this.$emit('selected', this.selected);
    },
    computed: {
      logo(){
          return this.selected.value ? this.options.find(el => el.value == this.selected.value) ? this.options.find(el => el.value == this.selected.value).logo : '' : '';
      },
      filteredOptions() {
        const filtered = [];
        const regOption = new RegExp(this.searchFilter, 'ig');
        for (const option of this.options) {
          if (this.searchFilter.length < 1 || option.text.match(regOption)){
            if (filtered.length < this.maxItem) filtered.push(option);
          }
        }
        return filtered;
      },
      requiredValid() {
        return !(this.required && (this.selected.value == undefined || this.selected == null || this.selected.value == ''));
      },
      state() {
        if (!this.validForm) return null;

        if (!this.requiredValid) return false;
        if (this.hasError) return false;
        return true;
      },
      feedback() {
        if (!this.requiredValid)
          return (
            this.requiredMessage ||
            this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
              name: this.label,
            })
          );
        
        return "";
      },
    },
    methods: {
      valid() {
        this.validForm = true;
        return this.state;
      },
      selectOption(option) {
        this.selected = option;
        this.optionsShown = false;
        this.searchFilter = this.selected.text;
        this.$emit('selected', this.selected);
        this.$emit('input', this.selected.value);
      },
      showOptions(){
        if (!this.disabled) {
          this.searchFilter = '';
          this.optionsShown = true;
        }
      },
      exit() {
        if (!this.selected.value) {
          this.selected = {};
          this.searchFilter = '';
        } else {
          this.searchFilter = this.selected.text;
        }
        this.$emit('selected', this.selected);
        this.optionsShown = false;
      },
      // Selecting when pressing Enter
      keyMonitor: function(event) {
        this.optionsShown = true;
        if (event.key === "Enter" && this.filteredOptions[0])
          this.selectOption(this.filteredOptions[0]);
      },
      valueAtualizado(value){
        let option = this.options.find(option => option.value == value);
        if(option) {
          this.selected = option;
          this.searchFilter = this.selected.text;
        }
      }
    },
    watch: {
      searchFilter() {
        /*if (this.filteredOptions.length === 0) {
          this.selected = {};
        } else {
          this.selected = this.filteredOptions[0];
        }*/
        this.$emit('filter', this.searchFilter);
      },
      value : {
        handler: function(value) {
          this.valueAtualizado(value);
        },
        deep: true,
        immediate: true,
      },
      options : {
        handler: function() {
          this.valueAtualizado(this.value);
        },
        deep: true,
        immediate: true,
      }
    }
  };
</script>


<style lang="scss" scoped>
  .dropEmpresa {
    display: flex !important;
    align-content: center !important;
    justify-content: flex-start !important;
    border-radius: 50px !important;
    height: inherit !important;
    flex-direction: inherit;

    .form-group{
        margin: 0px !important;
    }
    .dropEmpresa-field{
        border:none;
        border-radius: 0px !important;
        border-color: #fff;
        color: #fff;
        font-weight: 600;
        text-shadow: 1px 1px 1px #666;
        &:focus{
            font-weight: inherit;
            border-bottom: 1px solid;
        }
        &::placeholder{
            color: #fff;
        }
        &::-ms-input-placeholder{
            color:#fff;
        }
    }
    
    .dropEmpresa:hover .dropEmpresacontent {
      display: block;
    }
    
  }
  .dropEmpresa-content {
      position: absolute;
      background-color: #fff;
      max-height: 248px;
      border: 1px solid #e7ecf5;
      /*box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);*/
      overflow: auto;
      z-index: 1;
        margin-top: 1px;
        min-width: 350px;
        max-width: 100%;
      .dropEmpresa-item {
        color: black;
        font-size: 13px;
        line-height: 1em;
        padding: 8px;
        text-decoration: none;
        display: block;
        cursor: pointer;
        &:hover {
          background-color: #e7ecf5;
        }
      }
    }
</style>